import React, { useMemo } from 'react';
import { compact } from 'lodash';
import {
  ManagerLayoutSideNavigation,
  useAllowedForRoles,
  ChatIcon,
  UserRoles,
  useAppLayout,
  useAppChat,
} from '@monument/core';

const useMenuItems = () => {
  const { isAllowed: isSuperAdmin } = useAllowedForRoles([UserRoles.SuperAdmin]);
  const { unreadMessages } = useAppChat();

  const items = useMemo(
    () =>
      compact([
        {
          icon: 'home',
          route: '/dashboard',
          label: 'Dashboard',
          exactMatch: true,
        },
        {
          icon: 'clinician-menu',
          route: '/clinicians',
          label: 'Clinicians',
          patterns: ['/clinicians'],
        },
        isSuperAdmin && {
          icon: 'reviews',
          route: '/admins',
          label: 'Admins',
          patterns: ['/admins'],
        },
        {
          icon: 'appointments',
          route: '/appointments',
          label: 'Appointments',
        },
        {
          icon: 'reviews-menu',
          route: '/reviews',
          label: 'Reviews',
        },
        {
          icon: ({ className }) => <ChatIcon unread={unreadMessages} iconClassName={className} />,
          route: '/chat',
          label: 'Chat',
        },
        {
          icon: 'insurance',
          route: '/insurance',
          label: 'Insurance',
          patterns: ['/insurance', '/encounters', '/payer-contracts', '/eligibility'],
        },
        {
          icon: 'templates',
          route: '/message-previews',
          label: 'Templates',
        },
      ]),
    [unreadMessages, isSuperAdmin],
  );

  return items;
};

export const Navigation = () => {
  const menuItems = useMenuItems();

  const { menuCollapsed, setMenuCollapsed } = useAppLayout();

  return (
    <ManagerLayoutSideNavigation
      items={menuItems}
      menuCollapsed={menuCollapsed}
      setMenuCollapsed={setMenuCollapsed}
      showLogout={false}
    />
  );
};
